"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _ramda = require("ramda");

var _personalProfileSettings = require("../../store/personalProfileSettings/personalProfileSettings.contants");

var _timezones = require("../../../Shared/store/timezones");

var _timezones2 = require("../../../Shared/store/timezones/timezones.helpers");

var _personalProfileSettings2 = require("../../store/personalProfileSettings");

var _MeetingSettingItem = _interopRequireDefault(require("./MeetingSettingItem"));

var _BufferTimeItem = _interopRequireDefault(require("./BufferTimeItem"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MeetingSetting = function MeetingSetting(_ref) {
  var calendarTimezone = _ref.calendarTimezone,
      hideBusyCalendarPeriods = _ref.hideBusyCalendarPeriods,
      isAutoSendInvite = _ref.isAutoSendInvite,
      meetingDuration = _ref.meetingDuration,
      meetingFrequency = _ref.meetingFrequency,
      meetingLimits = _ref.meetingLimits,
      meetingPlace = _ref.meetingPlace,
      isLoading = _ref.isLoading,
      errors = _ref.errors,
      onSave = _ref.onSave;
  var bufferTimeInMinutes = (0, _reactRedux.useSelector)(_personalProfileSettings2.getBufferTimeInMinutes);
  var timezones = (0, _reactRedux.useSelector)(_timezones.Timezones.selectors.getTimezones);

  var _useState = (0, _react.useState)(calendarTimezone),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      timeZone = _useState2[0],
      setTimeZone = _useState2[1];

  var _useState3 = (0, _react.useState)(hideBusyCalendarPeriods.toString()),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      respect = _useState4[0],
      setRespect = _useState4[1];

  var _useState5 = (0, _react.useState)(bufferTimeInMinutes),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      bufferTime = _useState6[0],
      setBufferTimeInMinutes = _useState6[1];

  var _useState7 = (0, _react.useState)(meetingDuration),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      duration = _useState8[0],
      setDuration = _useState8[1];

  var _useState9 = (0, _react.useState)(meetingFrequency),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      frequency = _useState10[0],
      setFrequency = _useState10[1];

  var _useState11 = (0, _react.useState)(meetingLimits.finishIn),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      finishIn = _useState12[0],
      setFinishIn = _useState12[1];

  var _useState13 = (0, _react.useState)(meetingPlace.place),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      place = _useState14[0],
      setPlace = _useState14[1];

  var _useState15 = (0, _react.useState)(meetingPlace.additionalInfo),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      placeAdditional = _useState16[0],
      setPlaceAdditional = _useState16[1];

  var timezonesOptions = (0, _react.useMemo)(function () {
    var timezonesMap = timezones.map(function (timezone) {
      return _objectSpread(_objectSpread({}, timezone), {}, {
        disabled: false
      });
    });
    return timezones.findIndex(function (tz) {
      return tz.name === calendarTimezone;
    }) === -1 && !!calendarTimezone ? [].concat((0, _toConsumableArray2.default)(timezonesMap), [{
      name: calendarTimezone,
      title: calendarTimezone,
      disabled: true
    }]) : timezonesMap;
  }, [calendarTimezone, timezones]);
  var handleSetPlace = (0, _react.useCallback)(function (placeValue) {
    setPlace(placeValue);
    setPlaceAdditional('');
  }, []);
  var handleSaveCalendarPreferences = (0, _react.useCallback)(function () {
    onSave({
      meetingLimits: _objectSpread(_objectSpread({}, meetingLimits), {}, {
        finishIn
      }),
      hideBusyCalendarPeriods: respect === 'true',
      meetingFrequency: frequency,
      meetingDuration: duration,
      bufferTimeInMinutes: bufferTime,
      autoSendMeetingInviteToRecipient: isAutoSendInvite,
      meetingPlace: {
        place,
        additionalInfo: placeAdditional || ''
      },
      calendarTimezone: timeZone
    });
  }, [duration, finishIn, frequency, isAutoSendInvite, meetingLimits, onSave, place, placeAdditional, respect, timeZone, bufferTime]);
  var timezoneOptionsRenderer = (0, _react.useCallback)(function () {
    return (0, _ramda.map)(function (option) {
      return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
        disabled: option.disabled || false,
        key: option.name,
        value: option.name
      }, (0, _timezones2.formatTimezoneTitle)(option));
    }, timezonesOptions);
  }, [timezonesOptions]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_MeetingSettingItem.default, {
    dataTestId: "Dashboard-PersonalSettings-CalendarPreferences-Timezone",
    title: "SET YOUR TIMEZONE",
    label: "Your timezone",
    value: timeZone,
    onUpdate: setTimeZone,
    options: timezonesOptions,
    error: errors.calendarTimezone,
    isLoading: isLoading,
    renderItems: timezoneOptionsRenderer
  }), /*#__PURE__*/_react.default.createElement(_MeetingSettingItem.default, {
    dataTestId: "Dashboard-PersonalSettings-CalendarPreferences-FreeBusy",
    title: "RESPECT FREE / BUSY ON YOUR CALENDAR",
    description: "This lets you set whether or not gifts that have meeting requirements tied to them should respect your calendar if you\u2019re busy or out of office.",
    label: "Should this integration respect your calendar?",
    value: respect,
    onUpdate: setRespect,
    options: _personalProfileSettings.MEETING_BUSY_OPTIONS,
    error: errors.hideBusyCalendarPeriods,
    isLoading: isLoading
  }), /*#__PURE__*/_react.default.createElement(_MeetingSettingItem.default, {
    dataTestId: "Dashboard-PersonalSettings-CalendarPreferences-MeetingLength",
    title: "DEFAULT MEETING LENGTH",
    description: "This lets you define how long your meetings with the recipient will be.",
    label: "How long should your meetings be?",
    value: duration,
    onUpdate: setDuration,
    options: _personalProfileSettings.MEETING_DURATION_OPTIONS,
    error: errors.meetingDuration ? errors.meetingDuration : null,
    isLoading: isLoading
  }), /*#__PURE__*/_react.default.createElement(_MeetingSettingItem.default, {
    dataTestId: "Dashboard-PersonalSettings-CalendarPreferences-StartIntervals",
    title: "MEETING START TIME INTERVALS",
    description: "This lets you define how precise your meeting start time can be set. For example, if you set this to be 15 minutes with a 30 minute meeting length, your time slots will be 9:00 - 9:30, 9:15 - 9:45 etc.",
    label: "How frequent can your meetings be arranged?",
    value: frequency,
    onUpdate: setFrequency,
    options: _personalProfileSettings.MEETING_FREQUENCY_OPTIONS,
    error: errors.meetingFrequency ? errors.meetingFrequency : null,
    isLoading: isLoading
  }), /*#__PURE__*/_react.default.createElement(_BufferTimeItem.default, {
    bufferTimeInMinutes: bufferTime,
    onUpdate: setBufferTimeInMinutes,
    errors: errors.bufferTimeInMinutes ? errors.bufferTimeInMinutes : null,
    isLoading: isLoading
  }), /*#__PURE__*/_react.default.createElement(_MeetingSettingItem.default, {
    dataTestId: "Dashboard-PersonalSettings-CalendarPreferences-AvailabilityWindow",
    title: "MEETING AVAILABILITY WINDOW",
    description: "This lets you define how far out you\u2019ll allow a recipient to schedule a meeting.",
    label: "How far out can a recipient book a meeting?",
    value: finishIn,
    onUpdate: setFinishIn,
    options: _personalProfileSettings.MEETING_LIMIT_OPTIONS,
    error: errors.meetingLimits ? errors.meetingLimits.finishIn : null,
    isLoading: isLoading
  }), /*#__PURE__*/_react.default.createElement(_MeetingSettingItem.default, {
    dataTestId: "Dashboard-PersonalSettings-CalendarPreferences-MeetingPlace",
    title: "DEFAULT MEETING PLACE",
    description: "This lets you define how you\u2019d like to speak with the recipient. You can choose either phone call, video call, or in person meetings. This will apply to all gifts sent as you with a Required Action: Book a Meeting",
    label: "Where should your meetings take place?",
    value: place,
    onUpdate: handleSetPlace,
    options: _personalProfileSettings.MEETING_PLACE_OPTIONS,
    error: errors.meetingPlace ? errors.meetingPlace.place : null,
    isLoading: isLoading
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    id: "personal-settings-settings-place-additional-info",
    variant: "outlined",
    label: _personalProfileSettings.MEETING_PLACE_PLACEHOLDERS[place],
    fullWidth: true,
    margin: "normal",
    error: !!(errors.place && errors.place.additionalInfo),
    helperText: errors.place ? errors.place.additionalInfo : null,
    value: placeAdditional,
    onChange: function onChange(e) {
      return setPlaceAdditional(e.target.value);
    },
    placeholder: _personalProfileSettings.MEETING_PLACE_PLACEHOLDERS[place],
    disabled: isLoading
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_ui.ActionButton, {
    onClick: handleSaveCalendarPreferences,
    disabled: isLoading
  }, "Save")));
};

MeetingSetting.propTypes = {
  calendarTimezone: _propTypes.default.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errors: _propTypes.default.object,
  hideBusyCalendarPeriods: _propTypes.default.bool.isRequired,
  isLoading: _propTypes.default.bool,
  meetingLimits: _propTypes.default.shape({
    finishIn: _propTypes.default.number
  }).isRequired,
  meetingDuration: _propTypes.default.number.isRequired,
  meetingFrequency: _propTypes.default.number.isRequired,
  meetingPlace: _propTypes.default.shape({
    additionalInfo: _propTypes.default.string,
    place: _propTypes.default.string
  }).isRequired,
  isAutoSendInvite: _propTypes.default.bool.isRequired,
  onSave: _propTypes.default.func.isRequired
};
MeetingSetting.defaultProps = {
  errors: {},
  isLoading: false
};
var _default = MeetingSetting;
exports.default = _default;